import './AnalyticsGuide.css';

/**
 * ActionHint — shows a contextual suggestion box when an operational issue is detected.
 *
 * Props:
 *   condition  (bool)    – render only when true (issue detected)
 *   icon       (string)  – emoji/icon (optional, default '⚠️')
 *   message    (string)  – main message describing the issue
 *   actions    (Array<{ label: string, href?: string, onClick?: fn }>)  – suggested actions
 *   severity   ('warning' | 'error' | 'info')  – default 'warning'
 */
export default function ActionHint({ condition, icon, message, actions = [], severity = 'warning' }) {
    if (!condition) return null;

    const defaultIcons = { warning: '⚠', error: '✕', info: 'ℹ' };
    const displayIcon = icon || defaultIcons[severity] || '⚠';

    return (
        <div className={`action-hint action-hint--${severity}`} role="alert">
            <span className="action-hint-icon">{displayIcon}</span>
            <div className="action-hint-content">
                <div className="action-hint-message">{message}</div>
                {actions.length > 0 && (
                    <div className="action-hint-actions">
                        {actions.map((action, i) =>
                            action.href ? (
                                <a
                                    key={i}
                                    href={action.href}
                                    className="action-hint-btn"
                                >
                                    {action.label}
                                </a>
                            ) : (
                                <button
                                    key={i}
                                    className="action-hint-btn"
                                    onClick={action.onClick}
                                >
                                    {action.label}
                                </button>
                            )
                        )}
                    </div>
                )}
            </div>
        </div>
    );
}
